import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import MenuItem from '@mui/material/MenuItem';
import MuiTextField, {} from '@mui/material/TextField';
function SelectInner({ label, options, value, onChange, error, hint, placeholder, id, size = 'medium', fullWidth = true, ...rest }, ref) {
    const autoId = useId();
    const fieldId = id ?? autoId;
    return (_jsxs(MuiTextField, { ref: ref, select: true, id: fieldId, label: label, size: size, fullWidth: fullWidth, value: value, onChange: (e) => onChange(e.target.value), error: Boolean(error), helperText: error ?? hint, slotProps: {
            select: {
                displayEmpty: Boolean(placeholder),
                ...(placeholder
                    ? {
                        renderValue: (v) => v === '' ? (_jsx("span", { style: { opacity: 0.6 }, children: placeholder })) : ((options.find((o) => o.value === v)?.label ?? String(v))),
                    }
                    : {}),
            },
        }, ...rest, children: [placeholder && (_jsx(MenuItem, { value: "", disabled: true, children: placeholder })), options.map((o) => (_jsx(MenuItem, { value: o.value, disabled: o.disabled, children: o.label }, o.value)))] }));
}
export const Select = forwardRef(SelectInner);
//# sourceMappingURL=select.js.map